import { useEffect } from "react";
import { useFieldArray } from "react-hook-form";
import StarIcon from "@material-ui/icons/Star";
import StarBorderIcon from "@material-ui/icons/StarBorder";

import { IUser } from "../../../../../types/user/iuser.interface";
import { User } from "../../../../../components/user/user.component";
import { makeKey } from "../../../../../utils/helpers";
import { withShowIf } from "../../../../../components/with-show-if/with-show-If.component";

import { CheckboxField } from "../../../../forms/fields/checkbox-field/checkbox-field.component";
import { SelectedItems } from "../../../../common-attributes/components/selected-items/selected-items.component";
import { UserSearchFieldSelectionProps } from "../../../../forms/fields/user-search-field/components/user-search-field-selection/user-search-field-selection.props";

import { SelectedItem } from "./user-search-field-selection.styles";

export const UserSearchFieldSelection = withShowIf((props: UserSearchFieldSelectionProps) => {
  const { users } = props;
  const userMarkers = (user: IUser) => (props.userMarkers && props.userMarkers(user)) ?? [];

  const { fields, append, remove } = useFieldArray({
    control: props.form.control,
    keyName: "key",
    name: "contentCreators",
    shouldUnregister: false,
  });

  useEffect(() => {
    if (users.length > fields.length) {
      const user = users[users.length - 1];
      append({
        userDetails: user,
        isCreativePrime: false,
        workOrder: props.resourceId,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [users]);

  const onRemove = (userId: number, index: number) => {
    remove(index);
    props.onRemove(userId);
  };

  return (
    <SelectedItems>
      {fields.map((field: any, index: number) => (
        <SelectedItem key={makeKey(field.key, index)}>
          <CheckboxField
            iconChecked={<StarIcon />}
            icon={<StarBorderIcon />}
            form={props.form}
            name={`contentCreators.${index}.isCreativePrime`}
            userPermissions={props.userPermissions}
          />
          <User
            isDisabled={props.isUserReadonly(field.userDetails)}
            markers={userMarkers(field.userDetails)}
            onRemove={(userId: number) => onRemove(userId, index)}
            user={field.userDetails}
          />
        </SelectedItem>
      ))}
    </SelectedItems>
  );
});
